<template>
	<div class="clients-list">
		<vx-card class="my-8">
			<vs-tabs v-if="tabs.length > 0" @setActiveTab="setActiveTab">
				<vs-tab
					v-for="tab in tabs"
					:key="tab.title"
					:value="indexTab"
					:counter="getTabCounter(currentPageList)"
					:label="$t(tab.title)"
				>
					<div class="perPage">
						<v-select class="single-row-select"
								  v-model="select1"
								  :searchable="false"
								  :options="[10,20,50]"/>
					</div>
					<div class="tab-text ">

						<vs-table
							:sst="true"
							:max-items="select1"
							@change-page="setPageNumber"
							pagination
							:data="currentPageList"
							:currentPage="currentPage"
							:total="totalClients"
						>
							<template slot="thead">
								<vs-th v-for="fil in field" class="text-capitalize" :style="'width:' +fil.width"
									   :class="{'justify-center': fil.align && fil.align === 'center'}">
									{{ $capitalizeFirstLetter($t(fil.title)) }}
								</vs-th>
							</template>
							<template slot-scope="{ data }">
								<vs-tr class="vs-table-filters">
									<template v-for="fil in field">
										<vs-td v-if="fil.field === 'name'">
											<vs-input class="w-full" v-model="searchName"
													  @input="filterTable"></vs-input>
										</vs-td>
										<vs-td v-else-if="fil.field === 'email'">
											<vs-input class="w-full" v-model="searchEmail"
													  @input="filterTable"></vs-input>
										</vs-td>
										<vs-td v-else-if="fil.field === 'phone'">
											<vs-input class="w-full" v-model="searchPhone"
													  @input="filterTable"></vs-input>
										</vs-td>
										<vs-td v-else></vs-td>
									</template>
								</vs-tr>
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<template v-for="fil in field">
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-if="fil.field === 'name'">
											<router-link :to="'client/' + tr.id">
												{{ getClientName(tr.first_name, tr.last_name) }}
											</router-link>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'client.username'">
											<!--											<router-link :to="'client/' + deepFind(tr, 'client.id')">-->
											<router-link to="/">
												{{ deepFind(tr, fil.field) }}
											</router-link>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'author.username'">
											<router-link v-if="tr[fil.field]"
														 :to="'client/' + deepFind(tr, 'author.id')">
												{{ deepFind(tr, fil.field) }}
											</router-link>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'chat_messages_count'">
											<span
												class="counter"
												:class="{ warn: tr.has_new_message }"
											>
												{{ tr.chat_messages_count }}
											</span>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'subject'">
											{{
												subjects.find((obj) => {
													return obj.id === tr.subject;
												}).name
											}}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'work_type'">
											{{
												works.find((obj) => {
													return obj.id === tr.work_type;
												}).name
											}}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'quality_level'">
											{{
												levels.find((obj) => {
													return obj.id === tr.quality_level;
												}).name
											}}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'task'">
											<span class="task"
												  v-if="tr[fil.field]">{{
													tr[fil.field].date_time | moment('DD.MM.YYYY')
												}}</span>
											<span class="task" @click="idOrder = tr.id;activePrompt = true"
												  v-else>+</span>
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'price'">
											{{ tr[fil.field] }}
										</vs-td>
                    <vs-td
											v-else-if="fil.field === 'unread_messages_count'"
											:class="{'text-center': fil.align && fil.align === 'center'}"
										>
											<div class="flex justify-center">
											<span
												class="counter"
												:class="{ warn: tr.has_new_message }"
											>
												{{ tr.chat_messages_count }}
											</span>
											</div>
										</vs-td>
										<!-- <vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'unread_messages_count'">
											{{ tr.unread_messages_count }}
										</vs-td> -->
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'is_enabled_for_junior'">
											{{ tr[fil.field] ? $t('yes') : $t('no') }}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'actions'">
											<div class="flex justify-center">
                        <div
                        class="flex justify-center chat"
                        @click="openChat(tr.id)"
                      >
												<vs-custom-button
													size="small"
													color="#626262"
													type="flat"
													icon-pack="feather"
													icon="edit"
												>
													<feather-icon icon="MessageSquareIcon"></feather-icon>
												</vs-custom-button>
											</div>
												<vs-custom-button
													size="small"
													color="#626262"
													type="flat"
													icon-pack="feather"
													@click="loginAs(tr)"
													icon="edit"
												>
													<feather-icon icon="LogInIcon"></feather-icon>
												</vs-custom-button>
												<vs-custom-button
													size="small"
													color="#626262"
													type="flat"
													icon-pack="feather"
													@click="$router.push('/client/'+tr.id+'/edit')"
													icon="edit"
												>
													<feather-icon icon="EditIcon"></feather-icon>
												</vs-custom-button>
											</div>
										</vs-td>
										<vs-td
											v-else-if="tr[fil.field] || tr[fil.field] === 0"
											:class="{'text-center': fil.align && fil.align === 'center'}"
										>{{ tr[fil.field] }}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
											...
										</vs-td>
									</template>
									<template v-if="isManagerOrAdmin">
										<vs-td v-if="tab.key === 'clients'">
											<span
												class="cursor-pointer text-danger"
												@click="blockUser(tr)"
											>
												<feather-icon badge size="1.5x" icon="Trash2Icon"></feather-icon>
											</span>

										</vs-td>
										<vs-td v-else-if="tab.key === 'ban_clients'">
										<span
											class="d-flex cursor-pointer text-success"
											@click="unblockUser(tr)"
										>
											<feather-icon badge size="1.5x" icon="Trash2Icon"></feather-icon>
										</span>

										</vs-td>
									</template>

								</vs-tr>
							</template>
						</vs-table>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>
	</div>
</template>

<script>
import vSelect from 'vue-select'
import debounce from 'debounce'
import notifier from "@/mixins/notifier";
import databaseManager from "@/mixins/databaseManager";
import clientsHeaders from "@/assets/configs/clientsHeaders";

export default {
	name: "typeWorks",
	mixins: [notifier, databaseManager],
	components: {
		'v-select': vSelect,
	},
	computed:{
		isManagerOrAdmin(){
			return ['admin','manager'].includes(this.$store.state.auth.role)
		},
		currentPageList() {
			let item = this.tabs[this.indexTab];
			return item.key === 'clients'
				? this.clients
				: this.ban_clients;
		}
	},
	data() {
		return {
			searchName: '',
			searchEmail: '',
			searchPhone: '',

			select1: 10,
			nameRu: '',
			nameDe: '',
			price: '',
			juniorIs: false,

			currentPage: 1,
			totalClients: 1,

			indexTab: 0,
			tabs: [],
			tabsHasMessageSet: new WeakSet(),

			activePrompt: false,
			activePromptEdit: false,
			popupActiv: false,
			subjects: [],
			clients: [],
			ban_clients: [],

			editModel: {}
		};
	},
	methods: {
		openChat(id) {
		  try {
			this.$store.dispatch('getMessages',{userId: id}); this.$router.push({ query: { userId: id } })
		  } catch (e) {
			this.notifyError(e.message);
		  }
		},
		async setPageNumber(data) {
			this.currentPage = data;
			await this.getWorks()
		},
		async setActiveTab(data) {
			const prev = this.indexTab;
			this.indexTab = data;
			if (prev === 0 && this.indexTab < 1) return;
			this.currentPage = 1;
			await this.getWorks()
		},
		unblockUser(user){
			this.$vs.dialog({
				color: "success",
				title: this.$t(`confirmUnblockingUser`),
				acceptText: this.$t(`confirm`),
				cancelText: this.$t(`doCancel`),
				text: `${this.$t('confirmUnblocking')} "${user.first_name || ''} ${user.last_name || ''}"`,
				accept: async () => {
					try {
						const response = (await this.$http.post(
							`/admin/client/activate/${user.id}`
						)).data;
						if(response.status === 200){
							this.notifySuccess(this.$t('user_unbanned_successfully'));
							await this.getWorks();
						}else{
							throw new Error('Something went wrong')
						}
					} catch (e) {
						this.notifyError(e.message);
					}
				}
			})
		},
		blockUser(user){
			this.$vs.dialog({
					color: "danger",
					title: this.$t(`confirmBlockingUser`),
					acceptText: this.$t(`confirm`),
					cancelText: this.$t(`doCancel`),
					text: `${this.$t('confirmBlocking')} "${user.first_name || ''} ${user.last_name || ''}"`,
					accept: async () => {
						try {
							const response = (await this.$http.post(
								`/admin/client/ban/${user.id}`
							)).data;
							if(response.status === 200){
								this.notifySuccess(this.$t('user_banned_successfully'));
								await this.getWorks();
							}else{
								throw new Error('Something went wrong')
							}
						} catch (e) {
							this.notifyError(e.message);
						}
					}
			})
		},
		getClientName(firstName, lastName) {
			const fullName = [firstName, lastName].join(" ");
			return fullName !== " " ? fullName : "---";
		},
		getTabCounter(works) {
			return {
				value: works.length,
				color: this.tabsHasMessageSet.has(works) ? "orange" : undefined
			};
		},
		async loginAs(client) {
			try {
				const url = `/admin/client/get-token?email=${client.email}`;
				const res = (await this.$http.get(url)).data.data;
				window.open(`/token/${res.role}/${res.token}`);

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		filterTable: debounce(function (e) {
			// this.clients = []
			// this.ban_clients = []
			// let options = '?';
			// if (this.searchName.length > 0) options += 'filter[name]=' + this.searchName + '&'
			// if (this.searchEmail.length > 0) options += 'filter[email]=' + this.searchEmail + '&'
			// if (this.searchPhone.length > 0) options += 'filter[phone]=' + this.searchPhone
			let item = this.tabs[this.indexTab];
			item.key === 'clients'
				? this.clients = []
				: this.ban_clients = [];

      this.currentPage = 1
			this.getWorks();
		}, 500),
		async removeTask() {
			try {
				await this.$http.post("/admin/client/delete/" + this.editModel.id);

				this.notifySuccess(this.$t('deletedSuccessfully'));
				this.editModel = {};
				this.getWorks();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async editTask(id) {
			try {
				let validator = await this.$validator.validateAll();
				if (!validator) return this.activePromptEdit = true;
				let formData = {
					"name_ru": this.editModel.name_ru,
					"name_de": this.editModel.name_de,
					"price": this.editModel.price,
					"is_enabled_for_junior": this.editModel.is_enabled_for_junior
				}
				await this.$http.post("/admin/client/update/" + this.editModel.id, formData);

				this.notifySuccess(this.$t('changedSuccessfully'));
				this.editModel = {};
				this.activePromptEdit = false;
				this.getWorks();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async createTask(id) {
			try {
				let validator = await this.$validator.validateAll();
				if (!validator) return this.activePrompt = true;
				let formData = {
					"name_ru": this.nameRu,
					"name_de": this.nameDe,
					"price": this.price,
					"is_enabled_for_junior": this.juniorIs
				}
				await this.$http.post("/admin/client/create", formData);

				this.notifySuccess(this.$t('addedSuccessfully'));
				this.nameRu = "";
				this.nameDe = "";
				this.price = "";
				this.juniorIs = false;
				this.popupActiv = false;
				this.getWorks();

			} catch (e) {
				this.$vs.notify({
					title: "Error",
					text: e.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			}
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		// async getWorks(options = '') {
		// 	for (let item of this.tabs) {
		// 		if(item.key === "ban_clients"){
		// 			options += (options ? '&' : '?') + 'tab=ban';
		// 		}

		// 		try {
		// 			let url = options ? "/admin/client" + options : "/admin/client";
		// 			const res = (await this.$http.get(url)).data.data;
		// 			this.works[item.key] = res || [];
		// 		} catch (e) {
		// 			this.$vs.notify({
		// 				title: "Error",
		// 				text: e.message,
		// 				iconPack: "feather",
		// 				icon: "icon-alert-circle",
		// 				color: "danger",
		// 			});
		// 		}
		// 	}
		// },
		async getWorks() {
			let options = {
				name: this.searchName,
				email: this.searchEmail,
				phone: this.searchPhone
			}

			let item = this.tabs[this.indexTab];
			const offset = (this.currentPage - 1) * this.select1;
			let tab;
			item.title === "ban_clients" ? tab = 'ban' : tab = '';

			const clientsList = this.currentPageList;

			let reqOptions = {
				...options,
				tab: tab,
				limit: this.select1,
				offset: offset
			}

			try {
				const res = await this.dbGetClientsList(reqOptions);
				this.totalClients = res.count;
				if (res.data === null) return;



				for (let i = 0; i < offset; i++) {
					this.$set(clientsList, i, res.data[0])
				}

				for (let i = 0; i < res.data.length; i++) {
					this.$set(clientsList, offset + i, res.data[i])
				}

			} catch (e) {
				this.$vs.notify({
					title: "Error",
					text: e.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			}

		},
	},
	watch: {
		select1(newVal) {
			if (newVal) {
				this.getWorks()
			}
		}
	},
	created() {
		const headers = clientsHeaders.getHeaders();
		this.field = headers.field;
		this.tabs = headers.tabs;
	},
	mounted() {
		this.getWorks();
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.vs__dropdown-menu {
  min-width: fit-content;
}

.text-capitalize{
	text-transform: capitalize !important;
}
.clients-list {
	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}

	.perPage {
    width: 65px;
    flex: 0 0 auto;

		.vs__dropdown-toggle {
			border-radius: 100px;
			padding: 0;
		}
		.vs__selected-options {
			padding-left: 13px;
			.vs__selected {
				padding: 0;
				flex: 0 0 auto;
				padding: 0;
			}
		}

		.vs__clear {
			display: none;
		}

		.vs__search {
			padding: 0;
			flex: 0 0 0;
		}

		.v-select__selection {
			width: 100%;
			justify-content: center;
		}
	}

	.inputInTable {
		border: 0;
		resize: none;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}

	.buttons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}

	.justify-center .vs-table-text {
		justify-content: center;
	}

	.vs-checkbox-default {
		flex-shrink: 0;
	}

	.vs-tabs--content {
		padding: 0;
		margin-top: 10px;
	}

	.vs-con-table .vs-con-tbody {
		border: 0;
		background-color: transparent;
	}

	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}

	.con-vs-tabs .con-slot-tabs {
		overflow: visible;
	}

	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}

	.counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #f0ad4e;
			color: white;
			border-color: #f0ad4e;
		}
	}

	.filter {
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 1rem;
		padding-top: 0.5rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.date {
			display: flex;
			align-items: center;
		}

		.vx-input-group .vx-input-group-default .vs-input {
			width: 150px;
		}

		.vx-input-group {
			margin-right: 20px;
		}

		.search .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}

		.search .vs-con-input-label {
			width: 270px;
		}
	}
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}

.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}

	.vs-popup--content {
		padding: 0;
	}

	table {
		width: 100%;

		td {
			padding-bottom: 4px;
		}
	}

	.body {
		padding: 1rem;

		table {
			margin-left: -2px;
		}

		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}

	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;

		button {
			margin-left: 10px;
		}
	}

	.counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #f0ad4e;
			color: white;
			border-color: #f0ad4e;
		}
	}
}
</style>
